// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c81vhk{font:var(--ds-font-heading-xxsmall,normal 600 9pt/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._18zrpxbi{padding-inline:var(--ds-space-200,1pc)}\n._1rjcze3t{padding-block:var(--ds-space-0,0)}\n._syaz1vvm{color:var(--_bbz764)}", ""]);
// Exports
module.exports = exports;
